function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#FF4E00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0H24V24H0z",
  transform: "translate(4 5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.316 17.583l.003.004 6.322 6.266c.095.095.224.149.359.149.135 0 .264-.054.359-.149l6.322-6.266.003-.004.004-.003c.416-.41.746-.9.971-1.438.226-.54.342-1.118.342-1.702 0-.584-.116-1.163-.342-1.702-.225-.539-.555-1.028-.971-1.438-.844-.833-1.982-1.3-3.168-1.3-1.186 0-2.324.467-3.168 1.3l-.003.004-.004.003-.345.343-.345-.342-.004-.003-.003-.003c-.844-.833-1.982-1.3-3.168-1.3-1.186 0-2.324.467-3.168 1.3-.416.41-.746.9-.97 1.438-.226.54-.342 1.117-.342 1.701 0 .585.116 1.163.341 1.702.225.539.555 1.028.971 1.438l.004.002z",
  clipRule: "evenodd"
});

var SvgFavTrue = function SvgFavTrue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFavTrue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fav-true.6051226d.svg";
export { ForwardRef as ReactComponent };